<template>
    <v-container v-if="appStore.User.CanAccessPortal" class="content-container pb-14">

        <!-- Welcome message -->
        <!-- <div class="card card--white d-flex align-center ga-4 mb-8">
            <img src="@assets/images/dashboard/icon-welcome.svg" alt="Dobrodošli">
            <div class="page-heading__text mb-0">
                <span class="font-weight-600">Dobrodošli v prenovljenem portalu</span>
                – z novim imenom, osveženo podobo in izboljšano uporabniško izkušnjo, kot del NLB Skupine. Še naprej vam
                stojimo ob strani pri vsakem koraku do sklenitve nakupa na obroke.
            </div>
        </div> -->

        <!-- Stats panels -->
        <v-row class="row-stats">

            <!-- Btn Create contract -->
            <v-col class="pa-2">
                <div class="card card--primary card--compact h-100 d-flex btn-contract-create" @click="GotoVnosPogodbe">
                    <div>Vnos pogodbe</div>
                    <img src="../../assets/images/components/icon-btn-plus-24.svg" alt="Plus" class="ml-2"></img>
                </div>
            </v-col>

            <!-- Created contracts -->
            <v-col class="pa-2">
                <div class="card card--default card--compact card-stats h-100" @click="GoToAll">

                    <!-- Trend -->
                    <v-tooltip v-if="pogodbeStore.DashStats.PercentVal != 0"
                        :text="pogodbeStore.DashStats.PercentVal + ' % več kot prejšnje obdobje'" location="bottom">
                        <template v-slot:activator="{ props }">
                            <img v-if="pogodbeStore.DashStats.Trend == 'U'"
                                src="@assets/images/dashboard/icon-stats-up.svg" alt="Narašča" />
                            <img v-else-if="pogodbeStore.DashStats.Trend == 'D'"
                                src="@assets/images/dashboard/icon-stats-down.svg" alt="Pada" />
                        </template>
                    </v-tooltip>

                    <div>
                        <!-- Label -->
                        <div class="card-stats__label">
                            <span v-if="pogodbeStore.DashStats.ContractCount == 1">Vnesena pogodba</span>
                            <span v-else-if="pogodbeStore.DashStats.ContractCount == 2">Vneseni pogodbi</span>
                            <span
                                v-else-if="pogodbeStore.DashStats.ContractCount == 3 || pogodbeStore.DashStats.ContractCount == 4">
                                Vnesene pogodbe
                            </span>
                            <span v-else>Vnesenih pogodb</span>
                            {{ $t(`Dashboard.Interval.${pogodbeStore.DashStats.Interval}`) }}
                        </div>

                        <!-- Number -->
                        <div class="card-stats__number">{{ pogodbeStore.DashStats.ContractCount }}</div>
                    </div>

                </div>

            </v-col>

            <!-- Contracts to proccess -->
            <v-col class="pa-2">
                <div class="card card--default card--compact card-stats h-100" @click="GoToForProccessing">

                    <!-- Pulse -->
                    <div v-if="pogodbeStore.DashStats.ForProcessing > 0" class="pulse-element"></div>

                    <div>
                        <!-- Label -->
                        <div class="card-stats__label">
                            <span v-if="pogodbeStore.DashStats.ForProcessing == 1">Pogodba</span>
                            <span v-else-if="pogodbeStore.DashStats.ForProcessing == 2">Pogodbi</span>
                            <span
                                v-else-if="pogodbeStore.DashStats.ForProcessing == 3 || pogodbeStore.DashStats.ForProcessing == 4">Pogodbe
                            </span>
                            <span v-else>Pogodb</span>
                            <span> za obdelavo</span>
                        </div>

                        <!-- Number -->
                        <div class="card-stats__number">{{ pogodbeStore.DashStats.ForProcessing > 0 ?
                            pogodbeStore.DashStats.ForProcessing : '0' }}
                        </div>
                    </div>

                </div>
            </v-col>

            <!-- Messages to read -->
            <v-col class="pa-2">
                <div class="card card--default card--compact card-stats h-100" @click="GoToNotRead">

                    <!-- Pulse -->
                    <div v-if="pogodbeStore.DashStats.ForProcessing > 0" class="pulse-element"></div>

                    <div>
                        <!-- Label -->
                        <div class="card-stats__label">
                            <span v-if="pogodbeStore.DashStats.Unread == 1">Neprebrano sporočilo</span>
                            <span v-else-if="pogodbeStore.DashStats.Unread == 2">Neprebrani sporočili</span>
                            <span v-else-if="pogodbeStore.DashStats.Unread == 3 || pogodbeStore.DashStats.Unread == 4">
                                Neprebrana sporočila
                            </span>
                            <span v-else>Neprebranih sporočil</span>
                        </div>

                        <!-- Number -->
                        <div class="card-stats__number">{{ pogodbeStore.DashStats.Unread > 0 ?
                            pogodbeStore.DashStats.Unread
                            : '0' }}
                        </div>
                    </div>

                </div>
            </v-col>

        </v-row>

        <!-- Card Novosti -->
        <!-- <v-row>
            <v-col>
                <div class="card card--default mb-0">

                    <div class="card__kicker">Novosti pri pregledu dokumentacije</div>

                    <div class="section-heading mt-0">Pogodbe z dokumentacijo sedaj pregledane takoj</div>

                    <div class="mb-4">
                        Obveščamo vas o pomembni izboljšavi pri obravnavi dokumentacije za obročno plačilo, ki bo poenostavila
                        vaše delo
                        in pohitrila proces.<br />
                        Od sedaj bomo:</div>
                    <ol class="pl-8">
                        <li class="mb-4"><span class="font-weight-600">Pregledovali dokumentacijo tudi po 16.
                                uri</span>, kar
                            omogoča hitrejše obravnave.</li>
                        <li class="mb-4"><span class="font-weight-600">Neposredno komunicirali s stranko glede
                                manjkajoče
                                dokumentacije</span>, s čimer vas razbremenimo tega
                            dela.</li>
                        <li>Po odobritvi pogodbe boste prek aplikacije prejeli ustrezni status, kar pomeni, da pogodba
                            ne bo preklicana ali zavrnjena. Tako lahko varno in takoj izdate blago stranki.</li>
                    </ol>
                    <br />

                    V primeru vprašanj smo vam na voljo.<br /><br />

                    Ekipa NLB Buy&Go

                </div>

            </v-col>
        </v-row> -->

        <!-- Other POS users (non-auto broker) -->
        <v-row v-if="appStore.User.AvtoBroker == false">

            <!-- Prednosti -->
            <v-col class="v-col-12 v-col-md-5 v-col-lg-5">

                <div class="card card--white card-for-who  h-100">

                    <div class="requirements">

                        <div class="section-heading mt-0">Prednosti NLB Buy&Go</div>

                        <div class="requirement">
                            <img src="@assets/images/dashboard/icon-who-15k.svg" alt="1" class="">
                            <div>Do 15.000 EUR</div>
                        </div>
                        <div class="requirement">
                            <img src="@assets/images/dashboard/icon-who-slo.svg" alt="1" class="">
                            <div>Za komitente vseh bank.</div>
                        </div>
                        <div class="requirement">
                            <img src="@assets/images/dashboard/icon-who-25.svg" alt="2" class="">
                            <div>Za osebe stare med 18 in 80 let.</div>
                        </div>
                        <div class="requirement">
                            <img src="@assets/images/dashboard/icon-who-tujina.svg" alt="2" class="">
                            <div>Za zaposlene v tujini.</div>
                        </div>
                        <div class="requirement">
                            <img src="@assets/images/dashboard/icon-who-sepa.svg" alt="2" class="">
                            <div>Za tuje državljane in zasebnike.</div>
                        </div>

                    </div>

                    <!-- Link infografika-->
                    <div class="link-infografika">
                        Več informacij v <span
                            @click="fw4.ShowDocumentStatic('/StaticDocs/NLB Buy&Go Infografika Splosna.pdf', '')">infografiki</span>.
                    </div>

                </div>

            </v-col>

            <!-- Infografika -->
            <v-col class="v-col-12 v-col-md-7 v-col-lg-7">

                <div class="card card--primary card-info  h-100">

                    <!-- Stranka requirements -->
                    <div class="section-heading mt-2">Stranka za sklenitev pogodbe potrebuje</div>

                    <div class="customer-requirements">

                        <div class="customer-requirement">
                            <img src="@assets/images/dashboard/icon-customer-1.svg" alt="1" class="">
                            <div>Osebni dokument</div>
                        </div>

                        <div class="customer-requirement">
                            <img src="@assets/images/dashboard/icon-customer-2.svg" alt="2" class="">
                            <div>Bančno kartico</div>
                        </div>

                        <div class="customer-requirement">
                            <img src="@assets/images/dashboard/icon-customer-3.svg" alt="3" class="">
                            <div>Davčno številko</div>
                        </div>

                        <div class="customer-requirement">
                            <img src="@assets/images/dashboard/icon-customer-4.svg" alt="4" class="">
                            <div>Mobilni telefon</div>
                        </div>

                        <div class="customer-requirement">
                            <img src="@assets/images/dashboard/icon-customer-5.svg" alt="5" class="">
                            <div>Informacijo o prihodkih</div>
                        </div>

                    </div>

                    <hr class="hr mt-4 mb-8" />

                    <!-- Posrednik requirements -->
                    <div class="partner-requirements">

                        <div class="section-heading mt-0">Posrednik za nakup na obroke</div>

                        <div class="partner-requirement">
                            <img src="@assets/images/dashboard/icon-customer-1.svg" alt="1" class="">

                            Predloži račun, predračun ali naročilo.
                        </div>

                    </div>

                    <!-- Link infografika-->
                    <div class="link-infografika">
                        Več informacij v <span
                            @click="fw4.ShowDocumentStatic('/StaticDocs/NLB Buy&Go Infografika Splosna.pdf', '')">infografiki</span>.
                    </div>

                </div>

            </v-col>

        </v-row>

        <!-- Auto broker users -->
        <v-row v-else>

            <v-col>
                <div class="card card--primary card-avto">

                    <div class="section-heading mt-2">Osnovne informacije za sklepanje hitrega avto obročnega plačila
                    </div>

                    <div>

                        <!-- Do 10k -->
                        <div class="avto-condition">
                            <img src="@assets/images/dashboard/icon-customer-1.svg" alt="1" class="">
                            <div>
                                Stranka lahko z enim bančnim izpiskom opravi nakup na obroke do 10.000 €, za nakup na
                                obroke do
                                15.000 € mora predložiti zadnje 3 bančne izpiske.
                            </div>
                        </div>

                        <!-- Tujci -->
                        <div class="avto-condition">
                            <img src="@assets/images/dashboard/icon-customer-2.svg" alt="1" class="">
                            <div>Tujci lahko pridobijo nakup na obroke do 5.000 €. S povprečno plačo nad 1.500 € v
                                zadnjih
                                treh mesecih, lahko pridobijo nakup na obroke do 8.000 €.</div>
                        </div>

                        <!-- Prometno dovoljenje -->
                        <div class="avto-condition">
                            <img src="@assets/images/dashboard/icon-customer-3.svg" alt="1" class="">
                            <div>Za izplačilo financiranega zneska <span class="font-weight-600">NE</span> potrebujemo
                                prometnega dovoljenja.
                            </div>
                        </div>

                        <!-- Minimalna plača -->
                        <div class="avto-condition">
                            <img src="@assets/images/dashboard/icon-customer-4.svg" alt="1" class="">
                            <div>Stranki mora ostati polovica plače/pokojnine ali najmanj 521,50 EUR (po odbitku vseh
                                obrokov, razvidnih iz SISBON-a za obstoječe kredite/leasinge in novim obrokom za
                                hitri avto nakup na obroke).</div>

                        </div>

                        <div class="avto-condition">
                            <img src="@assets/images/dashboard/icon-customer-5.svg" alt="1" class="">
                            <div>Ni vam več potrebno preverjati minimalnega zneska plače na bančnem izpisku, plačo
                                samo prepišete, vse ostalo opravi aplikacija sama.</div>
                        </div>
                    </div>

                    <!-- <div class="sign-in__image-curve-wrapper">
                        <div class="sign-in__image-curve"></div>
                    </div>
                    <div class="sign-in__image">
                        <img src="@assets/images/dashboard/img-avto.png" alt="Login image" />
                    </div> -->

                    <!-- Link infografika-->
                    <div class="link-infografika">
                        Več informacij v <span
                            @click="fw4.ShowDocumentStatic('/StaticDocs/NLB Buy&Go Infografika Avto.pdf', '')">infografiki</span>
                    </div>

                </div>
            </v-col>

        </v-row>

    </v-container>

    <Modal title="Obvestilo" :display="appStore.User.ShowDashNotification" @modalClosed="$emit('modalClosed')"
        acceptText="Potrdi" @accept="appStore.DashNotificationClose()" :showDeclineButton="false"
        :showCloseXButton="false" :disabledAccept="appStore.User.IsIdentificationSuccessful != true"
        class="modal-preconditions">
        <DashNotificationsModal @isFormValid="displayAcceptButton = $event" />
    </Modal>

</template>

<script setup lang="ts">
    import router from "@app/router";
    import { useAppStore } from "@/app/store/app/store";
    import { Ref, ref } from "vue";
    import Modal from "@/app/components/modal.vue";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
    import DashNotificationsModal from "./dash-notifications-modal.vue";
    import { useSeznamPogodbStore, ContractTabStatus, Interval } from "@/app/store/app/contract-list/store";

    const fw4 = useFw4Store();
    const appStore = useAppStore();
    const pogodbeStore = useSeznamPogodbStore();

    pogodbeStore.LoadDashData();

    let showReport: Ref<boolean> = ref(false);
    let src: Ref<string> = ref('');
    let displayAcceptButton = ref(true);

    let showMore: Ref<boolean> = ref(false);

    function toggleShowMore() {
        showMore.value = !showMore.value;
    };

    async function GotoVnosPogodbe() {
        if (appStore.User.CanAccessContract && (appStore.User.SisbonTraining == 3) && appStore.User.UserDisabled == false) {
            router.push({ name: "posOrder_home" });
        }
        else if (appStore.User.SisbonTraining == 1) {
            fw4.ShowMessageBox("Opozorilo", "Pred pričetkom sklepanja pogodb je potrebno opraviti obvezno izobraževanje o SISBON.", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
                { Id: "OK", Caption: "Opravi izobraževanje", Type: MessageBoxButtonType.OK, IsPrimary: true }
            ]).then((buttonId: any) => {
                if (buttonId == "OK") {
                    router.push({ name: "training_home" });
                }
            })
        }
        else if (appStore.User.SisbonTraining == 2) {
            await appStore.ContractCreateConsentLog();
            fw4.ShowMessageBox("Opozorilo", "Vaš profil ni več aktiven, saj v zadnjem mesecu niste vnesli pogodbe.<br/ > <br />Postopek ponovne aktivacije je sedaj v teku. Med delovnim časom bo aktivacija zaključena v nekaj minutah, sicer pa najkasneje naslednji delovni dan - takrat lahko nadaljujete z vnosom pogodb.", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Close]
            ])
        }
        else if (appStore.User.CanAccessContract && appStore.User.UserDisabled) {
            fw4.ShowMessageBox("Opozorilo", `Vaš dostop do vnosa nove pogodbe je začasno onemogočen. <br /><br/>Za ponovno aktivacijo potrebujemo od vašega delodajalca informacijo o upravičenosti do dostopa. Vljudno prosimo, da kadrovska služba ali druga odgovorna oseba v podjetju to informacijo posreduje na e-mail naslov <a href="mailto:prodaja@nlbbuygo.si">prodaja@nlbbuygo.si</a>.`, [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Close]
            ])
        }
        else {
            fw4.ShowMessageBox("Opozorilo", `Nimate pravic za sklepanje pogodb. <br/> <br/>Vljudno prosimo, da nas kontaktirate na e-mail naslov <a href="mailto:prodaja@nlbbuygo.si">prodaja@nlbbuygo.si</a>.`, [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Close]
            ])
        }
    };

    function GotoPreberiVec() {
        router.push({ name: "dashboard_preberivec" });
    };

    function GotoUporabniskiCenter() {
        router.push({ name: "uporabniski_center" });
    };


    function showIframe(value: string) {
        src.value = value;
        showReport.value = true;
    };

    async function GoToAll() {
        pogodbeStore.Filters.ContractTabStatus = ContractTabStatus.All;
        await pogodbeStore.getPogodbeSeznam();
        router.push({ name: 'seznam_pogodb_home' });
    };

    async function GoToForProccessing() {
        pogodbeStore.Filters.ContractTabStatus = ContractTabStatus.ForProcessing;
        await pogodbeStore.getPogodbeSeznam();
        router.push({ name: 'seznam_pogodb_home' });
    };

    async function GoToNotRead() {
        pogodbeStore.Filters.ContractTabStatus = ContractTabStatus.NotRead;
        await pogodbeStore.getPogodbeSeznam();
        router.push({ name: 'seznam_pogodb_home' });
    };
</script>